// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";
import { sceneFragmentDeclaration } from "core/Shaders/ShadersInclude/sceneFragmentDeclaration";
import { sceneUboDeclaration } from "core/Shaders/ShadersInclude/sceneUboDeclaration";
import { helperFunctions } from "core/Shaders/ShadersInclude/helperFunctions";
import { lightFragmentDeclaration } from "core/Shaders/ShadersInclude/lightFragmentDeclaration";
import { lightUboDeclaration } from "core/Shaders/ShadersInclude/lightUboDeclaration";
import { lightsFragmentFunctions } from "core/Shaders/ShadersInclude/lightsFragmentFunctions";
import { shadowsFragmentFunctions } from "core/Shaders/ShadersInclude/shadowsFragmentFunctions";
import { clipPlaneFragmentDeclaration } from "core/Shaders/ShadersInclude/clipPlaneFragmentDeclaration";
import { logDepthDeclaration } from "core/Shaders/ShadersInclude/logDepthDeclaration";
import { fogFragmentDeclaration } from "core/Shaders/ShadersInclude/fogFragmentDeclaration";
import { clipPlaneFragment } from "core/Shaders/ShadersInclude/clipPlaneFragment";
import { lightFragment } from "core/Shaders/ShadersInclude/lightFragment";
import { logDepthFragment } from "core/Shaders/ShadersInclude/logDepthFragment";
import { fogFragment } from "core/Shaders/ShadersInclude/fogFragment";
import { imageProcessingCompatibility } from "core/Shaders/ShadersInclude/imageProcessingCompatibility";

const name = "shadowOnlyPixelShader";
const shader = `precision highp float;
#include<__decl__sceneFragment>
uniform float alpha;uniform vec3 shadowColor;
#define ADDITIONAL_FRAGMENT_DECLARATION
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#include<helperFunctions>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<clipPlaneFragmentDeclaration>
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#if defined(CLUSTLIGHT_BATCH) && CLUSTLIGHT_BATCH>0
varying float vViewDepth;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=vec3(1.0,1.0,1.0);
#endif
vec3 diffuseBase=vec3(0.,0.,0.);lightingInfo info;float shadow=1.;float glossiness=0.;float aggShadow=0.;float numLights=0.;
#include<lightFragment>[0..1]
#define CUSTOM_FRAGMENT_BEFORE_LIGHT_COMPOSITION
vec4 color=vec4(shadowColor,(1.0-clamp(shadow,0.,1.))*alpha);
#include<logDepthFragment>
#include<fogFragment>
gl_FragColor=color;
#include<imageProcessingCompatibility>
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}
const includes = [sceneFragmentDeclaration, sceneUboDeclaration, helperFunctions, lightFragmentDeclaration, lightUboDeclaration, lightsFragmentFunctions, shadowsFragmentFunctions, clipPlaneFragmentDeclaration, logDepthDeclaration, fogFragmentDeclaration, clipPlaneFragment, lightFragment, logDepthFragment, fogFragment, imageProcessingCompatibility];
for (const inc of includes) {
    if (!ShaderStore.IncludesShadersStore[inc.name]) {
        ShaderStore.IncludesShadersStore[inc.name] = inc.shader;
    }
}

/** @internal */
export const shadowOnlyPixelShader = { name, shader };
